import { E2EEManager } from 'features/e2ee/E2EEManager';
import { SFrameManager } from 'features/e2ee/SFrameManager';
import { UserId } from 'features/users/types';

export const cleanupE2eeUser = (id: UserId, roomId: string, e2eeId: number) => {
  E2EEManager.removeReceiver(id, roomId);
  SFrameManager.deleteReceiver(e2eeId);
};
